import VehicleLeftRightArrow from "./VehicleLeftRightArrow";

export default VehicleLeftRightArrow;
